((w)=>{
if(!w.nlpiajs_flags) w.nlpiajs_flags = {f1:false,f2:false,f3:false,f4:false};
let simulateEvent = function(dom, evt, func) {dom.addEventListener(evt, func);};
let syncContent = function(oDom, fn) {
  if(!oDom || !fn) return; // normally, the variables are non-null.
  const callback = function(mutationsList, observer) {for (const mutation of mutationsList) {if (mutation.type === 'characterData' || mutation.type === 'childList') fn.call();}};
  new MutationObserver(callback).observe(oDom, {childList: true, subtree: true, characterData: true});
};
let watchTheHeight = function(target, callback, someArr) {
  const theObserver = new IntersectionObserver((entries) => {entries.forEach(callback);}, {threshold: someArr});
  theObserver.observe(target);
};
document.addEventListener('DOMContentLoaded', function() {
  // start pre-cart-reminder.liquid
  if(!w.nlpiajs_flags.f1 && document.querySelector("#product_floatboard_bottom_button_02")) {
    w.nlpiajs_flags.f1 = true;
    let SOME_HEIGHT = 100;
    let btns = document.querySelector(".multiple-btns").querySelectorAll(".btn:not(.d-none)"), bottomButton01 = document.querySelector("#product_floatboard_bottom_button_01"), bottomButton02 = document.querySelector("#product_floatboard_bottom_button_02"), theForm = document.querySelector("form.form.as-async-add-form"), buyBtn = document.querySelector(".as-form-button-wrap-fixed .multiple-btns").querySelector("a:not(.d-none)");
	if(bottomButton01){
      simulateEvent(
        bottomButton01, "click",
        () => {theForm.dispatchEvent(new Event("submit",{bubbles:true,cancelable:true}))}
      );      
    }
    let qtt = document.getElementById("quantity-input");
    if(qtt) {
      qtt.addEventListener('change', function(){
  	  if(bottomButton02) {bottomButton02.setAttribute("data-quantity", qtt.value);}
      });
    } else {
      if(bottomButton02) {bottomButton02.setAttribute("data-quantity", 1);}
    }
    if(bottomButton02) {
      bottomButton02.addEventListener("click", function(){
        bottomButton02.setAttribute("data-quantity", document.getElementById("quantity-input").value);
        buyBtn.click();
      });      
    }
    let price = document.querySelector(":not(.d-none).as-product-price"), t0 = document.querySelector(".cr-heighted-box"), t1 = document.querySelector(".cr-heighted-box .cr-figure-1"),
    copyContentHandler = function(){
      let cmpPrice = document.querySelector(":not(.d-none).as-product-compare-at-price"), discountDesc = document.querySelector(":not(.d-none).as-discount-tag");
      let t2 = document.querySelector(".cr-heighted-box .cr-figure-2 .cr-figure-2-1"), t3 = document.querySelector(".cr-heighted-box .cr-figure-2 .cr-figure-2-2 .cr-abs-r"), t3Parent = document.querySelector(".cr-heighted-box .cr-figure-2 .cr-figure-2-2");
      // copy task - 1
      t1.innerHTML = price.innerText;
      // copy task - 2
      if(cmpPrice) { t2.innerHTML = cmpPrice.innerText; t0.className = "cr-heighted-box"; } else { t2.innerHTML = price.innerText; t0.className = "cr-heighted-box cr-even"; }
      // copy task - 3
      if(discountDesc) { if(t3) {t3.innerHTML = discountDesc.innerText.replace("Save ","-"); t3.className = "cr-abs-r";} } else { t3Parent.innerHTML = "<div class='cr-abs-r cannot-see'>-"+window.formatAmount_20250812(0)+"</div>"; }

	  if(bottomButton02) {
		  let vid = document.querySelector("form.as-async-add-form input[name='id']"); if(vid) bottomButton02.setAttribute("data-variant-id", vid.value);
	  }
    };
    syncContent( price, copyContentHandler );

    const topSection = document.querySelector(".shopify-section.main-product-v2.as-main-product-v2"), keySection = topSection.parentNode.querySelector(".shopify-section:not(.main-product-v2.as-main-product-v2)");
    let h1 = keySection.getBoundingClientRect().height;
    SOME_HEIGHT = Math.min(h1 * 0.5, SOME_HEIGHT);
    let someRate = SOME_HEIGHT / h1, theArray = [someRate*0.9, someRate, someRate*1.1];
    const reminder = document.querySelector(".as-cart-reminder.purchase-section");
    let stdHeight = document.documentElement.clientHeight - SOME_HEIGHT;
    watchTheHeight(keySection, (entry) => {
      let targetRectTop = entry.boundingClientRect.top;
      let someName = "as-cart-reminder purchase-section";
      if(targetRectTop <= stdHeight) {
        someName = "as-cart-reminder purchase-section can-see";
      }
      reminder.className = someName;
    }, theArray);
  } // end pre-cart-reminder.liquid

  // start by product-details.liquid
  if(!w.nlpiajs_flags.f2 && document.querySelectorAll(".container.mt-section.mb-section")){
    w.nlpiajs_flags.f2 = true;
    document.querySelectorAll(".container.mt-section.mb-section .the-collapse-btn").forEach((b)=>{
      let bp=b.parentNode, bhb=bp.querySelector(".richtext-with-link.no-last-margin"), bh = bhb.querySelector("ul");
      // INIT
      bhb.setAttribute("style", "height:1.4em");
      bhb.setAttribute("data-pre-lo", "height:1.4em");
      bhb.setAttribute("data-pre-hi", "height:"+bh.getBoundingClientRect().height + "px");
      bhb.setAttribute("data-chk-flag", "N");
      // BIND
      let handleClick = (event)=>{
        if(bhb.getAttribute("data-chk-flag") == "N") {
          let theDesc = "height:"+bh.getBoundingClientRect().height + "px";
          if(theDesc != bhb.getAttribute("data-pre-hi")) { bhb.setAttribute("data-pre-hi", theDesc); }
          bhb.setAttribute("data-chk-flag", "Y");
        }
        if(bp.className.indexOf("pdc-hidden")==-1){
          bp.className = bp.className + " pdc-hidden";
          bhb.setAttribute("style", bhb.getAttribute("data-pre-lo"));
        }else{
          bp.className = bp.className.replace(" pdc-hidden","");
          bhb.setAttribute("style", bhb.getAttribute("data-pre-hi"));
        }
      };
      simulateEvent(b, "click", handleClick)
    });
  } // end by product-details.liquid

  if(!w.nlpiajs_flags.f5) {
    w.nlpiajs_flags.f5 = true;
    let $select = document.querySelector('.as-main-product-v2-container .as-product-variant');
    $select.addEventListener('change', ()=>{
      if(document.querySelectorAll(".radio-btn .radio-btn-input:checked")
          && document.querySelectorAll(".radio-btn .radio-btn-input:checked")[0]) {
        let value = document.querySelectorAll(".radio-btn .radio-btn-input:checked")[0].value;
        let target = document.querySelector(".as-form-button-wrap-fixed .mb-3 .v1-price-desc");
        if(value == 'For NEOS II') {
          if(target) target.classList.remove("d-none");
        } else if (value != 'For NEOS II Ultra' && value.indexOf('NEOS II') > -1) {
          if(target) target.classList.remove("d-none");
        } else {
          if(target) target.classList.add("d-none");
        }
      }
    });
  }
});

// amazon comment -> add container style
if(!w.nlpiajs_flags.f3){
  w.nlpiajs_flags.f3 = true;
  // add class to app's container (BwP comment)
  if(document.querySelector(".shopify-section.spaced-section .pt-section.pb-section")) {
    document.querySelector(".shopify-section.spaced-section .pt-section.pb-section").classList.add("container");
  }
}

// collapsible product detail
if(!w.nlpiajs_flags.f4){
  w.nlpiajs_flags.f4 = true;
  w.addEventListener("resize", function() {
    // start by product-details.liquid
    if(document.querySelectorAll(".container.mt-section.mb-section")) {
      document.querySelectorAll(".container.mt-section.mb-section .the-collapse-btn").forEach((b)=>{
        let bp=b.parentNode, bhb=bp.querySelector(".richtext-with-link.no-last-margin"), bh = bhb.querySelector("ul");
        bhb.setAttribute("data-pre-hi", "height:"+bh.getBoundingClientRect().height + "px");
	  });
    } // end by product-details.liquid
  });
} // end collapsible product detail

})(window);
